"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateOfBirthAndLicenceHeldForValidation = void 0;
const FalconValidationMethodBase_1 = require("./FalconValidationMethodBase");
/**
 * Validates that a driver selects 'license held for' valid in regard to date of birth
 */
class DateOfBirthAndLicenceHeldForValidation extends FalconValidationMethodBase_1.FalconValidationMethodBase {
    constructor(props, commandsExecutor) {
        super(commandsExecutor);
        this.POLICY_HOLDER_DRIVER_INDEX = "policyHolder";
        this.MIN_LEGAL_DRIVING_AGE = 17;
        this.getDriverToValidate = (interaction) => {
            var _a;
            if (this.props.driverIndex === this.POLICY_HOLDER_DRIVER_INDEX) {
                return interaction === null || interaction === void 0 ? void 0 : interaction.policyHolder;
            }
            return (_a = interaction === null || interaction === void 0 ? void 0 : interaction.additionalDrivers) === null || _a === void 0 ? void 0 : _a[this.props.driverIndex];
        };
        this.props = props;
        if (this.props.driverIndex === undefined || this.props.driverIndex === null) {
            throw new Error("Missing setting: 'driverIndex'");
            // valid values: "policyHolder" (for policy holder), "0".."4" (for additional drivers)
        }
    }
    validateInput(_input, context) {
        let interaction = this.getInteraction(context);
        if (!interaction) {
            return this.validResult();
        }
        const driverToValidate = this.getDriverToValidate(interaction);
        if (!driverToValidate.dateOfBirth || !driverToValidate.drivingExperience) {
            return this.validResult();
        }
        const dateOfBirth = new Date(driverToValidate.dateOfBirth);
        const today = new Date();
        let currentAge = today.getFullYear() - dateOfBirth.getFullYear();
        const hasHadBirthdayThisYear = today.getMonth() > dateOfBirth.getMonth() ||
            (today.getMonth() === dateOfBirth.getMonth() &&
                today.getDate() >= dateOfBirth.getDate());
        if (!hasHadBirthdayThisYear) {
            currentAge--;
        }
        const maxPossibleLicenceYears = currentAge - this.MIN_LEGAL_DRIVING_AGE;
        const selectedExperienceValue = driverToValidate.drivingExperience;
        const requiredMinimumYears = selectedExperienceValue - 1; // -1 as drivingExperience start from 1 for 'Less than 1 year'
        if (requiredMinimumYears > maxPossibleLicenceYears) {
            return this.invalidResult(this.getErrorMessage(context, "The selected driving experience is not possible based on the driver's date of birth."));
        }
        return this.validResult();
    }
}
exports.DateOfBirthAndLicenceHeldForValidation = DateOfBirthAndLicenceHeldForValidation;
//# sourceMappingURL=DateOfBirthAndLicenceHeldForValidation.js.map